import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import orderSlip from '../Assets/images/orderslip.png';
import PrintIcon from '@mui/icons-material/Print';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Tooltip } from '@mui/material';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function OrderSlipDialog({open , handleClose, recordData }) {
//   const [open, setOpen] = React.useState(false);


  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth= "lg"
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Invoice
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography variant='subtitle1'>
              Invoice Name: {recordData?.invooceRecord?.title}
          </Typography>
          <Typography variant='subtitle1'>
              Total price: {recordData?.totalProductprice}
          </Typography>
          <img src={orderSlip} style={{height: "513px"}}/>
        </DialogContent>
        <DialogActions style={{display: 'flex', justifyContent: 'space-evenly'}}>
            <Tooltip title="Print invoice">
               <PrintIcon style={{fontSize: '30px', cursor: "pointer"}} />
            </Tooltip>
            <Tooltip title="Download invoice">
               <CloudDownloadIcon style={{fontSize: '30px', cursor: "pointer"}} />
            </Tooltip>
           </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
